import React from 'react';

export function ListLoading({ message = 'Loading…' }) {
   return (
      <div className="jobs-empty" role="status" aria-live="polite">
         <i className="pi pi-spin pi-spinner text-3xl mb-3"></i>
         <p>{message}</p>
      </div>
   );
}
